/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'actions-operations-login': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M16.25 18.75h-7.5c-.69 0-1.25-.56-1.25-1.25v-1.875h1.25V17.5h7.5v-15h-7.5v1.875H7.5V2.5c0-.69.56-1.25 1.25-1.25h7.5c.69 0 1.25.56 1.25 1.25v15c0 .69-.56 1.25-1.25 1.25zm-7.131-5.881l2.237-2.244H2.5v-1.25h8.856L9.12 7.131 10 6.25 13.75 10 10 13.75l-.881-.881z"/>'
  }
})
